import { useContext } from 'react';
import { MediaPlayerContext } from '../context/MediaPlayerProvider';

export const useMediaPlayer = () => {
  const context = useContext(MediaPlayerContext);
  if (context === null) {
    throw new Error('User context must come from MediaPlayerProvider');
  }
  return context;
};
